/**
 * 新建计费比率设置
 */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './RateModal.module.scss';
import http from '@/assets/api/http';
import { connect } from 'react-redux';
import model from '@/reducers/system/rate/model';
import {
    Modal,
    message,
    Form,
    Input,
    Select,
    InputNumber
} from 'antd';

const FormItem = Form.Item;
const { Option } = Select;
const { TextArea } = Input;

const layout = {
    labelCol: {
        span: 4,
        offset: 2
    },
    wrapperCol: {
        span: 19,
    },
};

const TempModal = ({
    closeMode,
    getRetaStatus,
    rateStatus,
    ...restProps
}) => {

    const [title, setTitle] = useState(restProps.title);
    const [visible, setVisible] = useState(restProps.visible);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [form] = Form.useForm();


    useEffect(() => {
        getRetaStatus({ enumName: 'PfRatioSettingCodeEnum' });
    }, []);


    const _handleOk = () => {
        form.validateFields().then((values) => {
            let {
                rateName,
                ratevalue,
                remarks,
            } = values;

            let submitData = {
                settingName: rateName.label,
                settingCode: rateName.value,
                ratio: ratevalue,
                remark: remarks,
            };
            setConfirmLoading(true);
            http('/?cmd=com.xqxc.api.pig.mis.biz.platform.RatioSettingMisService.addRatioSetting', submitData, 'POST').then(() => {
                message.success('新建成功');
                setVisible(false);
                closeMode(true);
            }).catch((e = {}) => {
                message.error(e.message || '提交异常');
                setConfirmLoading(false);
            });
        }).catch(() => { });
    }

    const _handleCancel = () => {
        setVisible(false);
        closeMode();
    }


    return (
        <Modal
            width={520}
            centered
            title={title}
            visible={visible}
            confirmLoading={confirmLoading}
            onOk={_handleOk}
            onCancel={_handleCancel}
            destroyOnClose={true}
            keyboard={true}
            maskClosable={false}
            cancelText='取消'
            okText='确认'
        >

            <Form
                {...layout}
                className={styles.container}
                autoComplete='off'
                name="create"
                scrollToFirstError
                form={form}
            >
                <FormItem
                    name="rateName"
                    label='设置项'
                    colon={false}
                    rules={[{ required: true, message: '请选择' }]}>
                    <Select
                        labelInValue
                        showSearch
                        style={{ width: '270px' }}
                        placeholder="请选择"
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                            optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                        }
                    >
                        {rateStatus.map(item => <Option key={item.code} value={item.code}>{item.value}</Option>)}
                    </Select>
                </FormItem>
                <FormItem className={`${styles.flexCurt}`}>
                    <FormItem
                        name="ratevalue"
                        label="比例值"
                        colon={false}
                        rules={[
                            {
                                required: true
                            },
                        ]}
                    >
                        <InputNumber
                            style={{ width: 270, }}
                            min={0}
                            max={100}
                            keyboard={true}
                            placeholder='请输入(%)'
                            precision={1}
                        />
                    </FormItem>
                    <span className={styles.curt}>%</span>
                </FormItem>
                <FormItem
                    name="remarks"
                    colon={false}
                    label='说明'
                    rules={[{ required: true, min: 5 }]}
                >
                    <TextArea
                        style={{ width: 270, position: 'relative' }}
                        showCount
                        maxLength={255}
                        rows={4}
                    />
                </FormItem>
            </Form>
        </Modal>
    );

}

TempModal.propTypes = {
    data: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.object
    ]), // 弹框入参
    visible: PropTypes.bool.isRequired, // 是否显示弹框
    closeMode: PropTypes.func.isRequired, // 关闭弹框的回调函数
    title: PropTypes.string,// 弹框标题
    rateStatus: PropTypes.array,
    getRetaStatus: PropTypes.func,//设置项下拉数据(action)
};

const mapStateToProps = (state) => {
    return {
        rateStatus: state.rate.rateStatus,
    };
};

export default connect(mapStateToProps, model.actions)(TempModal);
